import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Dropdown } from "react-bootstrap";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import "./../utils/Style/component/sidebar.scss";
import useLoginAPI from "../api/loginAPI";
import { handleImageError } from "../utils/functions";
import {
  inactivityDuration,
} from "../utils/Constants";
import LegalNavbar from "./legal-navbar";
import InactivityTimeout from "../components/InactivityTimeout";
import PortalActionsQr from "../components/PortalActionsQr";
import {
  generateAuthorizationCode,
  getExpAuthCodeOnClose,
  setActionPayload,
  setActionType,
  setAdditionalData,
  setAuthorizationCode,
  setOpLoading,
  setQrData,
  setStatus,
  setValidationInfo
} from "../features/authorizationSlice";
import BlurLoading from "../components/BlurLoading";
import ValidationPopup from "../components/ValidationPopup";
import useCheckAuthorizationStatusHandler from "../app/checkAuthorizationStatusHandler";
import useLogout from "../api/logoutApi";
import useTodoApi from "../api/TodoApi";
import useRecentOrdersApi from "../api/RecentOrdersApi";

function Layout() {
  const [navClick, setNavClick] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [isOpenQr, setIsOpenQr] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useLogout();

  const { authorizationCode } = useSelector((state) => state.authorization);
  const { awaitCourrierOrdersCount, todoOrdersCount } = useSelector(
    (state) => state.deliveryOrdersCount
  );
  const dashboardOrdersSummary = useSelector(state => state.overview.dashboardOrdersSummary)

  const { GetDashboardOrdersSummary } = useRecentOrdersApi();
  const { GetOrdersToProcessCount } = useTodoApi();
  const role = sessionStorage.getItem("Role")

  useEffect(() => {
    GetDashboardOrdersSummary();
  }, []);

  useEffect(() => {
    if (role !== "Arz") {
      GetOrdersToProcessCount();
    }
  }, [])

  const Merchants = sessionStorage.getItem("Merchants")
    ? JSON.parse(sessionStorage.getItem("Merchants"))
    : [];
  const Entities = sessionStorage.getItem("Entities")
    ? JSON.parse(sessionStorage.getItem("Entities"))
    : [];

  const currentMerchant = parseInt(sessionStorage.getItem("EntityID"));
  const { checkQrAxios, GenerateWebSocketToken } = useLoginAPI();

  const inactivityTimer = new InactivityTimeout(inactivityDuration);
  inactivityTimer.resetInactivityTimer();
  inactivityTimer.clearInactivityTimer();

  useEffect(() => {
    const paths = location.pathname.split("/");
    const firstPath = paths[1] || "default";
    setNavClick(firstPath);
    sessionStorage.setItem("navClick", firstPath);
  }, [location]);

  useEffect(() => {
    checkQrAxios();
    GenerateWebSocketToken();
  }, []);

  const handleNavClick = (clickedLink) => {
    sessionStorage.setItem("navClick", clickedLink);
    setNavClick(clickedLink);
  };

  const renderLink = (label, name) => {
    const path = name.toLowerCase().replace(/ /g, "");

    return (
      <div className={(navClick === name || navClick.toLowerCase() === path) ? "subTitleClicked" : "subTitle"}>
        <button
          className={(navClick === name || navClick.toLowerCase() === path) ? "navLinkClicked" : "navLink"}
          onClick={() => {
            handleNavClick(name);
            navigate("/" + path);
          }}
        >
          {label ?? name}
        </button>
        {label === "New Orders" && (
          <span>({dashboardOrdersSummary?.newOrders?.count || 0})</span>
        )}
        {label === "Awaiting Courier" && (
          <span>({awaitCourrierOrdersCount || 0})</span>
        )}
        {label === "Cancelled Orders" && (
          <span>({dashboardOrdersSummary?.cancelledOrders?.count || 0})</span>
        )}
        {label === "Out for Delivery" && (
          <span>({dashboardOrdersSummary?.outForDeliveryOrders?.count || 0})</span>
        )}
        {label === "To Do" && (
          <span className="todo-count">({todoOrdersCount})</span>
        )}
      </div>
    );
  };


  // const renderLegalLink = (name, slug, isCount) => {
  //   const url = slug !== undefined ? slug : name.toLowerCase().replace(/ /g, "");
  //   return (
  //     <div className={navClick === url ? "subTitleClicked" : "subTitle"}>
  //       <button
  //         className={navClick === url ? "navLinkClicked" : "navLink"}
  //         onClick={() => {
  //           handleNavClick(url);
  //           navigate("/" + url);
  //         }}
  //       >
  //         {name}
  //       </button>
  //       {isCount ? <span className="count">{isCount}</span> : null}
  //     </div>
  //   );
  // };

  const handleLogout = async () => {
    await logout();
  }

  const onOpenQr = () => {
    setIsOpenQr(true);
  };

  const onCloseQr = () => {
    setIsOpenQr(false);
  };

  const onOpenQrAfterGenerate = (additionalInfo) => {
    dispatch(generateAuthorizationCode(additionalInfo));
    dispatch(setAdditionalData(additionalInfo));
    onOpenQr();
  };

  const onCloseQrWhilePending = () => {
    dispatch(setStatus("CLOSED"));
    dispatch(setOpLoading("idle"));
    const authCode = authorizationCode;
    dispatch(getExpAuthCodeOnClose({ authCode }));
    dispatch(setValidationInfo(null));
    onCloseQrReset();
  };

  const onCloseQrReset = () => {
    dispatch(setAuthorizationCode(""));
    dispatch(setQrData(""));
    dispatch(setStatus(""));
    dispatch(setActionType(""));
    dispatch(setActionPayload(null));
    onCloseQr();
  };

  useCheckAuthorizationStatusHandler(onCloseQrReset);

  return (
    <div className="container sidebar">
      <div className="row">
        <div className="col-lg-2 d-none d-lg-block g-0"></div>
        <div className="col-lg-2 d-none d-lg-block g-0 left">
          <div className="Logo">
            <img src="/Images/suyool_logo.png" alt="Logo" />
          </div>
          <div className="scrollSection">
            <LegalNavbar renderLink={renderLink} setNavClick={setNavClick} />
            <div className="bottomSide">
              <div className="Support">
                <img src="/Images/logo/support.png" alt="Logo" />
                <p>24h Support</p>
              </div>
              <p>contact@suyool.com</p>
              <p>+961 1 290 900</p>
            </div>
          </div>
        </div>

        <div className="col-lg-10 col-md-12 g-0 right">
          <div className="header">
            <div className="date d-none d-lg-block">
              {sessionStorage.getItem("EntityName")}
            </div>
            <div className="userInfo">
              <Dropdown show={showDropdown} onToggle={() => setShowDropdown(!showDropdown)}>
                <Dropdown.Toggle>
                  <div className="userToggel">
                    <div className="user">
                      <div className="user-profile">
                        {sessionStorage.getItem("EntityURL") ? (
                          <img
                            src={sessionStorage.getItem("EntityURL")}
                            onError={handleImageError}
                          />
                        ) : (
                          <img src="/Images/skash_emptypp.jpg" />
                        )}
                      </div>
                      <p className="userName">
                        {sessionStorage.getItem("UserName")}
                      </p>
                    </div>
                  </div>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item
                    type="button"
                    className="btn btn-warning"
                    onClick={handleLogout}
                    style={{ textDecoration: "none", background: "none" }}
                  >
                    Logout
                  </Dropdown.Item>
                  <div className="legal-list">
                    {Entities?.length > 0 &&
                      Entities.reduce((unique, o) => {
                        if (
                          !unique.some(
                            (obj) =>
                              obj.LegalEntityID === o.LegalEntityID &&
                              obj.LegalEntityName === o.LegalEntityName
                          )
                        ) {
                          unique.push(o);
                        }
                        return unique;
                      }, []).map((entity) => {
                        const isCurrentLegal = entity.LegalEntityID === currentMerchant;
                        return (
                          <>
                            <Dropdown.Item
                              type="button"
                              className={isCurrentLegal ? "legal active" : "legal"}
                            // onClick={isCurrentLegal ? () => {} : async () => { /* Your onClick logic here */ }}
                            >
                              <img
                                src={entity.LegalIconUrl ?? "/Images/skash_emptypp.jpg"}
                                alt=""
                              />
                              <span>{entity.LegalEntityName}</span>
                            </Dropdown.Item>
                            {Merchants?.length > 0 &&
                              (entity.LegalEntityID === Number(sessionStorage.getItem("LegalEntityID")) ||
                                isCurrentLegal) && (
                                <div className="merchant-list">
                                  {Merchants.reduce((unique, o) => {
                                    if (
                                      !unique.some(
                                        (obj) =>
                                          obj.MerchantID === o.MerchantID &&
                                          obj.MerchantName === o.MerchantName
                                      )
                                    ) {
                                      unique.push(o);
                                    }
                                    return unique;
                                  }, []).map((merchant, index) => {
                                    const isCurrentMerchant = merchant.MerchantID === currentMerchant;
                                    return (
                                      <Dropdown.Item
                                        type="button"
                                        className={isCurrentMerchant ? "merchant merch-active" : "merchant"}
                                      // onClick={isCurrentMerchant ? () => {} : async () => { /* Your onClick logic here */ }}
                                      >
                                        <div className="round"></div>
                                        {index !== Merchants.length - 1 && (
                                          <div className="line"></div>
                                        )}
                                        <span>{merchant.MerchantName}</span>
                                      </Dropdown.Item>
                                    );
                                  })}
                                </div>
                              )}
                          </>
                        );
                      })}
                  </div>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
          <Outlet context={[onOpenQrAfterGenerate, onCloseQrReset]} />
        </div>
      </div>
      <BlurLoading />
      <PortalActionsQr isOpen={isOpenQr} onClose={onCloseQrWhilePending} />
      <ValidationPopup onOpenQrAfterGenerate={onOpenQrAfterGenerate} />
    </div>
  );
}

export default Layout;
